/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Detailpage1Inputs */

const en__field_detailpage1 = /** @type {(inputs: _Field_Detailpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail page`)
};

const de__field_detailpage1 = /** @type {(inputs: _Field_Detailpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailseite`)
};

/**
* | output |
* | --- |
* | "Detail page" |
*
* @param {_Field_Detailpage1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_detailpage1 = /** @type {((inputs?: _Field_Detailpage1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Detailpage1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_detailpage1(inputs)
	return de__field_detailpage1(inputs)
});
export { _field_detailpage1 as "_field_detailPage" }